<template>
  <div
    :class="{ 'has-error': hasErrors, 'has-success': isValid, 'FormField--hasIcon': icon, 'mb-4':spaceBottom }"
    class="FormField"
  >
    <!--<slot name="label">-->
    <!--<label-->
    <!--class="control-label"-->
    <!--v-if="label">{{ label }} {{ errors ? '*' : '' }}</label>-->
    <!--</slot>-->
    <div
      :class="{ 'border-b border-orange pb-2': !transparent }"
      class="FormField-Body flex items-center ease"
    >
      <div
        v-if="icon"
        class="FormField-Icon flex mr-2 text-orange ease"
      >
        <v-icon :type="icon"/>
      </div>
      <slot
        :attrs="{ class: { input: true }, name, placeholder: resolvedAttribute }"
        :validator="preferredValidator"
        :errors="activeErrors"
        :has-errors="hasErrors"
        :first-error-message="firstErrorMessage"
      />
    </div>
    <slot
      :errors="activeErrors"
      :has-errors="hasErrors"
      :first-error-message="firstErrorMessage"
      name="errors"
    >
      <div
        v-if="hasErrors"
        class="help-block text-xs text-red p-1"
      >
        <div
          v-if="showSingleError"
          :data-validation-attr="firstError.validationKey"
        >
          {{ firstErrorMessage }}
        </div>
        <template v-if="!showSingleError">
          <div
            v-for="error in activeErrors"
            :key="error.validationKey"
            :data-validation-attr="error.validationKey"
            class="error"
          >
            {{ getErrorMessage(error.validationKey, error.params) }}
          </div>
        </template>
      </div>
    </slot>
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  mixins: [singleErrorExtractorMixin],
  props: {
    icon: {
      type: String,
      default: ''
    },
    transparent: {
      type: Boolean,
      default: false
    },
    spaceBottom: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isRequired () {
      return this.validator.hasOwnProperty('required')
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import 'utils';

$red: map_get($colors, red);
$green: map_get($colors, green);

.FormField.border-b-0 .FormField-Body {
  border-bottom: none;
}

.FormField-Body {
  .has-error & {
    border-color: $red;

    textarea.input {
      border-color: $red;
    }

    .FormField-Icon {
      color: $red;
    }

    input::placeholder {
      color: map_get($colors, red);
    }
  }

  .has-success & {
    border-color: $green;

    textarea.input {
      border-color: $green;
    }

    .FormField-Icon {
      color: $green;
    }
  }
}
</style>
